export const getInfoBoxIconClass = (icon) => {
  return icon || 'fa fa-info-circle';
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/InfoBox/utils/infoBoxHelpers.js